import { Link, NavLink } from "react-router-dom";
import cnBind from 'classnames/bind';

import { Icon } from "../Icon";
import { useTranslation } from 'react-i18next';

import styles from './Sidebar.module.scss';


type SidebarItemProps = {
  title: string;
  iconName?: string;
  path: string;
  isExternal?: boolean;
  withDivider?: boolean;
  isAvailable?: boolean;
  alt?: string;
}

const cx = cnBind.bind(styles);

export const SidebarItem = ({ title, path, iconName, isExternal = false, withDivider = false, isAvailable = true, alt }: SidebarItemProps) => {

  const { t } = useTranslation();

  const classes = cx(styles.sidebar_item_link, styles.active);
  if (!isAvailable) return null

  return !isExternal ? (
    <div className={styles.sidebar_item} title={t(`${alt}`)}>
      <NavLink to={path} className={({ isActive }) => (isActive ? classes : styles.sidebar_item_link)}>
        {iconName && (
          <div className={styles.sidebar_icon}>
            <Icon name={iconName} />
          </div>
        )}
        <div className={styles.sidebar_item_title}>{t(title)}</div>
      </NavLink>
      {/* TODO: remove divider duplicate */}
      {withDivider && <div className={styles.divider} />}
    </div>
  ) : (
    <div className={styles.sidebar_item} title={t(`${alt}`)}>
      <Link to={path} target="_blank" className={styles.sidebar_item_link}>
        {iconName && (
          <div className={styles.sidebar_icon}>
            <Icon name={iconName} />
          </div>
        )}
        <div className={styles.sidebar_item_title}>{t(title)}</div>
      </Link>
      {withDivider && <div className={styles.divider} />}
    </div>
  );

}
